/* eslint-disable */
import { nextfetchdata } from '@/shared/api/nextfetch'

import { SalesData, TPromotion, TPromotionProducts } from '../model/types'

const nextFetchConfig = { next: { revalidate: 60 } }

export const fetchPromotions = async (page = null, cookie = ``): Promise<SalesData | void> =>
	await nextfetchdata<SalesData>(`promotions?page=${page}&limit=40`, {
		credentials: 'include',
		...(cookie ? { headers: { cookie } } : {}),
		...nextFetchConfig
	})

export const fetchPromotion = async (code: string, cookie: string): Promise<TPromotion | void> =>
	await nextfetchdata<TPromotion>(`promotions/${code}`, { cookie })

export const fetchPromotionProducts = async (
	code,
	cookie,
	page = null,
	category = null,
	order = null,
	limit = '32'
): Promise<TPromotionProducts | void> => {
	const searchParams = new URLSearchParams({
		limit: String(limit),
		page: String(page)
	})

	if (category !== `all` && !!category) {
		searchParams.set('category', category)
	}

	if (order) {
		let normalizedOrder = String(order)

		if (normalizedOrder.startsWith(`order=`)) {
			normalizedOrder = normalizedOrder.slice(6)
		}

		const [orderValueRaw, directionPart] = normalizedOrder.split(`&`)

		const parsedOrder = new URLSearchParams(orderValueRaw.includes(`=`) ? orderValueRaw : `order=${orderValueRaw}`)
		const parsedDirection = new URLSearchParams(directionPart || ``)

		const orderValue = parsedOrder.get(`order`)
		const directionValue = parsedDirection.get(`direction`) || parsedOrder.get(`direction`) || ``

		if (orderValue) {
			searchParams.set(`order`, orderValue)
		}

		if (directionValue) {
			searchParams.set(`direction`, directionValue)
		}
	}

	return await nextfetchdata<TPromotionProducts>(`promotions/${code}/products?${searchParams.toString()}`, {
		credentials: 'include',
		...(cookie ? { headers: { cookie } } : {})
	})
}
